export const validations = {
  sendAmtValidation: [
    (v) => !!v || "Please enter the sending amount.",
    (v) => v > 0 || "Invalid sending amount.",
    (v) => /^[0-9]\d{0,9}(\.\d{1,3})?%?$/.test(v) || "Invalid sending amount.",
  ],
  imagerules: [
    (v) => v.size <= 5000000 || "Image size should be less than 5 MB!",
  ],
  paymentMode: [(v) => !!v || "Please select payment mode."],
  reciveAmtValidation: [
    (v) => !!v || "Please enter the receiving amount.",
    (v) => v > 0 || "Invalid receiving amount.",
    (v) =>
      /^[0-9]\d{0,9}(\.\d{1,3})?%?$/.test(v) || "Invalid receiving amount.",
  ],
  firstnameValidations: [
    (v) => !!v || "Please enter First name.",
    (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid First Name",
  ],
  lastnameValidations: [
    (v) => !!v || "Please enter Last name.",
    (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid First Name",
  ],
  dobValidations: [(v) => !!v || "Date of Birth is Required."],
  genderValidations: [(v) => !!v || "Please select gender."],
  nationalityValidations: [(v) => !!v || "Please select nationality."],
  OcupationValidations: [
    (v) => !!v || "Please enter ocupation.",
    (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid ocupation",
  ],
  emailValidations: [
    (v) => !!v || "Please enter E-mail id.",
    (v) =>
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
      "Invalid E-mail id.",
  ],
  postalcodeValidations: [
    (v) => !!v || "Please enter postal code.",
    (v) => /^[0-9]+$/.test(v) || "Invalid postal code.",
  ],
  walletRules: [(v) => /^[0-9]+$/.test(v) || "Invalid pin."],
  addressValidations: [
    (v) => !!v || "Please enter Address",
    (v) => /^([a-zA-Z0-9,.#'-/]+\s?)*$/.test(v) || "Invalid Address",
  ],
  phonenumberValidations: [(v) => !!v || "Please enter phone number"],
  reasonValidations: [(v) => !!v || "Please enter reason."],
  paymenttypeValidateions: [(v) => !!v || "Please select payment type."],
  remarksValidations: [
    (v) => !!v || "Please enter remarks.",
    (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid remarks",
  ],
  sourceoffundsValidation: [(v) => !!v || "Please enter source of funds."],
  bankadviceValidations: [
    (v) => !!v || "Please upload bank advice image file.",
    (v) => v.size <= 5000000 || "Image size should be less than 5 MB!.",
  ],
  idtypeValidations: [(v) => !!v || "Please select ID Type."],
  idnumberValidations: [(v) => !!v || "Please enter id number."],
  issuedateValidations: [(v) => !!v || "Please select issue date."],
  issuelocationValidations: [
    (v) => !!v || "Please enter issue location.",
    (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid issue location.",
  ],
  expirydateValidations: [(v) => !!v || "Please select expiry date."],
};
export const Partnervalidations = {
  logoRules: [
    (v) => this.isValidImageSize(v) || "File not allow more than 3MB",
  ],
  accountholderrules: [
    (v) => !!v || "Account holder Name is required",
    (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid  Account holder name",
  ],
  PostValidations: [
    (v) => !!v || "Please enter Designation ",
    (v) => /^([a-zA-Z0-9,.#'-/]?)*$/.test(v) || "Invalid Designation.",
  ],
  remarksValidations: [
    (v) => !!v || "Please enter remarks.",
    (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid remarks",
  ],
  Company_Name: [
    (v) => !!v || "Please enter Partner name.",
    // (v) =>
    //   /^[a-zA-Z!@#$%^&*()_+{}[\]:;<>,.?\\/~`|-\s]*$/.test(v) ||
    //   "Invalid Partner name",
    // (v) => !/\s{2,}/.test(v) || "Invalid Partner name",
  ],
  PartnerID: [
    (v) => !!v || "Please enter Short Name.",
    // (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid Short Name",
  ],
  PartnerType: [(v) => !!v || "Please select Partner Type."],
  agentType: [(v) => !!v || "Please select Agent Type."],
  KYB_KYCDoc_ID: [
    (v) => !!v || " KYB/KYC Doc ID is required",
    (v) => /^[a-zA-Z0-9]+$/.test(v) || " KYB/KYC Doc ID Number",
  ],
  CountryRules: [(v) => !!v || "Country is required"],
  entiityrules: [(v) => !!v || "Entity Type is required"],
  natureofbusinessrules: [(v) => !!v || "Nature of business is required"],
  CityRules: [(v) => !!v || "City is required"],
  StateRules: [(v) => !!v || "State is required"],
  Agreementdate: [(v) => !!v || "Agreement date is required"],
  SettlementCurrency: [(v) => !!v || "Settlement currency  is required"],
  Currency: [(v) => !!v || " Currency  is required"],
  payingPartner: [(v) => !!v || " Paying Partner  is required"],
  pin_generator: [(v) => !!v || "required"],
  pin_prefix: [(v) => !!v || "required"],
  pin_generator_type: [(v) => !!v || ""],
  time_zone: [(v) => !!v || "Time zone is required"],
  local_currency: [(v) => !!v || "required"],
  pin_no_of_digits: [
    (v) => !!v || "required",
    (v) => /^[0-9]+$/.test(v) || "Numerical values are allowed",
  ],
  balance: [
    (v) => !!v || "Balance is required",
    (v) => /^[0-9]+$/.test(v) || "Numerical values are allowed",
  ],
  barnchlimit: [
    (v) => !!v || "Branch limit is required",
    (v) => /^[0-9]+$/.test(v) || "Numerical values are allowed",
  ],
  paymentMode: [(v) => !!v || " Payment Mode  is required"],
  reciverType: [(v) => !!v || " Receiver Type   is required"],
  Settlementrate: [(v) => !!v || "Settlement rate is required"],
  TransCreditlimit: [(v) => !!v || "Transaction Credit limit  is required"],
  addressValidations: [
    (v) => !!v || "Please enter Address",
    (v) => /^([a-zA-Z0-9,.#'-/]+\s?)*$/.test(v) || "Invalid Address",
  ],
  Busiesslicesnce: [
    (v) => !!v || "Please enter Business License",
    (v) => /^([a-zA-Z0-9,.#'-/]?)*$/.test(v) || "Invalid Business License.",
  ],
  PinNo_Prefix: [
    (v) => !!v || "Please enter PinNo Prefix .",
    (v) => /^[0-9]+$/.test(v) || "Invalid PinNo Prefix .",
  ],
  transrules: [
    (v) => !!v || "Please enter Transaction Limit.",
    (v) => /^[0-9]+$/.test(v) || "Invalid Transaction Limit.",
  ],
  phonenumberValidations: [
    (v) => !!v || "Contact Number is required",
    (v) => /^(([0-9]*){20})$/.test(v) || "The value must be an integer number",
    (v) => (v && v.length >= 8) || "Contact Number must be more than 8 Numbers",
    (v) =>
      (v && v.length < 13) || "Contact Number must be less than 13 Numbers",
  ],
  emailValidations: [
    (v) => !!v || "Please enter E-mail id.",
    (v) =>
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
      "Invalid E-mail id.",
  ],
  FullnameValidations: [(v) => !!v || "Please enter full name"],
  banknameRules: [
    (v) => !!v || "Bank name is required",
    (v) => /^[a-zA-Z\s]+$/.test(v) || "Only alphabetic characters are allowed",
    (v) => !/\s{2,}/.test(v) || "Spaces is not allowed",
  ],
  bankroutingRules: [
    (v) => !!v || "Bank name is required",
    (v) => /^[0-9]+$/.test(v) || "Only numbers are allowed",
  ],
  accountNumberRules: [
    (v) => !!v || "Account number is required",
    (v) =>
      /^[a-zA-Z0-9]+$/.test(v) || "Only alphanumeric characters are allowed",
    (v) =>
      (v && v.length >= 9 && v.length <= 18) ||
      "Account number length must be between 9 and 18 characters",
  ],
  // imagerules: [
  //   (v) => v.size <= 5000000 || "Image size should be less than 5 MB!",
  // ],
};

export const AllowedCurrency = {
  Currency_Code: [
    (v) => !!v || "Please enter Currency Code.",
    (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid Currency Code",
  ],
  Currency_Name: [
    (v) => !!v || "Please enter Currency Name.",
    // (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid Currency Name",
  ],
  Is_Default: [(v) => !!v || "Is Default required"],
  Applied_For: [(v) => !!v || "Applied For required"],
};
export const stateDetails = {
  State_code: [
    (v) => !!v || "Please enter State Code.",
    (v) => /^([a-zA-Z0-9]+\s?)*$/.test(v) || "Invalid State Code",
  ],
  State_name: [
    (v) => !!v || "Please enter State Name.",
    (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid State Name",
  ],
};
export const partnerRoute = {
  countryRules: [
    (v) => !!v || "Country is required",
    (v) => /^[a-zA-Z0-9]*$/.test(v) || "No special characters allowed",
  ],
  paymentRules: [
    (v) => !!v || "Payment mode is required",
    (v) => /^[a-zA-Z0-9]*$/.test(v) || "No special characters allowed",
  ],
  partnerRules: [
    (v) => !!v || "Partner is required",
    (v) => /^[a-zA-Z0-9]*$/.test(v) || "No special characters allowed",
  ],
  currencyRules: [
    (v) => !!v || "Currency is required",
    (v) => /^[a-zA-Z0-9]*$/.test(v) || "No special characters allowed",
  ],
};
export const AdditionalCountryInfo = {
  numbersOnly: [(v) => !!v || "Allow integer only"],
  sanctionFilter: [
    (v) => !!v || "Field is required",
    (v) => (v && v <= 100) || "maximum Percentage is 100",
    // (v) => /^[a-zA-Z\s]*$/.test(v) || "Should not allow",
    // (v) => !/^\s/.test(v) || "Space at the beginning is not allowed",
    // (v) => !/\s$/.test(v) || "Space at the end is not allowed",
    // (v) => !/\s{2,}/.test(v) || "Spaces is not allowed",
  ],
  bankAccount: [(v) => !!v || "Allow integer only"],
  paymentMode: [(v) => v.length > 0 || "please select payment mode"],
  riskType: [(v) => !!v || "please select risk type"],
  timezone: [(v) => !!v || "please select time zone"],
  partnerType: [(v) => v.length > 0 || "please select partner type"],
};
export const BranchUserSetup = {
  salutation: [(v) => !!v || "Please select tittle"],
  agent_type: [(v) => !!v || "Please select Agent type"],
  pwdChangeDays: [(v) => !!v || "Please enter pwd days"],
  country_Rules: [(v) => !!v || "Country is required"],
  time_zone: [(v) => !!v || "Time zone is required"],
  login_type: [(v) => !!v || "Login type is required"],
  userId: [
    (v) => !!v || "Please enter user ID.",
    (v) => !/\s/.test(v) || "Invalid user ID",
  ],
  optionalEmailValidations: [
    (v) => !!v || "Please enter E-mail.",
    (v) =>
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
      "Invalid E-mail id.",
  ],
  mobilenumberValidations: [
    (v) => !!v || "Mobile Number is required",
    (v) => /^(([0-9]*){20})$/.test(v) || "The value must be an integer number",
    (v) => (v && v.length >= 8) || "Mobile Number must be more than 8 Numbers",
    (v) => (v && v.length < 12) || "Mobile Number must be less than 12 Numbers",
  ],
};
export const BranchValidations = {
  branchCode: [(v) => !!v || "Please enter Branch code"],
  accountNumber: [
    (v) => !!v || "Please enter Bank account number",
    (v) =>
      /^[a-zA-Z0-9]+$/.test(v) || "Only alphanumeric characters are allowed",
    (v) =>
      (v && v.length >= 9 && v.length <= 18) ||
      "Account number length must be between 9 and 18 characters",
  ],
  bankName: [(v) => !!v || "Please enter Bank Name"],
  bankBranch: [(v) => !!v || "Please enter Bank branch"],
};
export const masterBankandBranch = {
  bankCodeRules: [(v) => !!v || "Please Enter Bank Code"],
  banknameRules: [(v) => !!v || "Please Enter Bank Name"],
  countryRules: [(v) => !!v || "Please select Country"],
  paymentModeRules: [(v) => !!v || "Please select Payment Mode"],
  branchNameRules: [(v) => !!v || "Please Enter Branch Name"],
  branchCodeRules: [(v) => !!v || "Please Enter Branch Code"],
  phoneNumberRules: [
    (v) => !!v || "Please Enter Phone Number",
    (v) => (v && v.length >= 8) || "Phone Number must be more than 8 Numbers",
    (v) => (v && v.length < 12) || "Phone Number must be less than 12 Numbers",
  ],
  addressRules: [(v) => !!v || "Please Enter Address"],
};
export const FieldRequired = (val) => {
  return [(v) => !!v || `${val} is required`];
};
export const FieldNumbRequired = (val) => {
  return [(v) => (v !== null && v !== "") || `${val} is required`];
};
export const ledgerRules = {
  ledgerDesc: [(v) => v.length < 200 || "Entered text is too long."],
  ledgerNamerules: [(v) => v.length < 30 || "Entered text is too long."],
};
